import React, { memo } from 'react';
import { string, shape, number, arrayOf } from 'prop-types';
import Radium from 'radium';
import { WithLoading } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';

import styles from './styles.module.scss';

const IdentityValidation = ({ identityValidationForm }) => (
  <UTForm fields={identityValidationForm} replaceFieldNames formClasses={{ formContainer: styles.form }} />
);

IdentityValidation.propTypes = {
  identityValidationForm: arrayOf(
    shape({
      answer: arrayOf(string),
      field_type: string,
      id: number.isRequired,
      order: number.isRequired,
      question: string
    })
  )
};

export default WithLoading(props => props.loading)(memo(Radium(IdentityValidation)));
